import { useEffect } from "react";
import { useLocation } from "wouter";

type QuickCreateKind = "goal" | "task" | "habit" | "note" | "event";

/**
 * Opens a page's create UI when reached from the global Quick Create menu.
 * The query flag is consumed so reload/back navigation does not reopen it.
 */
export function useQuickCreateRoute(kind: QuickCreateKind, openCreate: () => void) {
  const [location] = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("quickCreate") !== kind) return;

    openCreate();
    params.delete("quickCreate");
    const query = params.toString();
    window.history.replaceState(
      window.history.state,
      "",
      `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`,
    );
  }, [kind, location, openCreate]);
}